import type { PostCategory, ReportReason } from '@/api/pending'

export const CATEGORY_LABEL: Record<PostCategory, string> = {
  announcement: 'Comunicado',
  warning: 'Aviso',
  danger_warning: 'Urgente',
  reminder: 'Lembrete',
  doubt: 'Dúvida',
  suggestion: 'Sugestão',
  post: 'Publicação',
}

export const REASON_LABEL: Record<ReportReason, string> = {
  racial_injury: 'Injúria racial',
  sexual_content: 'Conteúdo sexual',
  other: 'Outro',
}

export const authorName = (a: { first_name: string; last_name: string }) =>
  `${a.first_name} ${a.last_name}`.trim()
